import Head from 'next/head';
import React from 'react';

function generateGoogleTagManagerScript(containerId: string): string {
  return `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${containerId}');
`;
}

function generateDataLayerScript() {
  return `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
`;
}

export interface GoogleAnalyticsProps {
  readonly containerId: string;
}

const GoogleAnalytics: React.FC<GoogleAnalyticsProps> = ({ containerId }) => {
  return (
    <>
      <Head>
        <script
          key="google-analytics-data-layer"
          dangerouslySetInnerHTML={{
            __html: generateDataLayerScript(),
          }}
        ></script>
        <script
          key="google-analytics-script"
          dangerouslySetInnerHTML={{
            __html: generateGoogleTagManagerScript(containerId),
          }}
        ></script>
      </Head>
      <noscript key="google-analytics-noscript">
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${containerId}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        ></iframe>
      </noscript>
    </>
  );
};

export default GoogleAnalytics;
